import qs from "qs"

interface Props {
  locale?: string | any
  populate?: any
  query?: Record<any, any>
  wrappedByKey?: string
  wrappedByList?: boolean
}

export default async function fetchApi<T>(
  endpoint: string,
  { locale, populate, query = {}, wrappedByKey, wrappedByList }: Props = {}
): Promise<T> {
  if (endpoint.startsWith("/")) {
    endpoint = endpoint.slice(1)
  }

  let currentLocale = locale
  if (!currentLocale) {
    try {
      const nuxtApp = useNuxtApp()
      if (nuxtApp && nuxtApp.$i18n) {
        currentLocale = (nuxtApp.$i18n.locale as any).value || "tr"
      } else {
        currentLocale = "tr"
      }
    } catch {
      currentLocale = "tr"
    }
  }

  query["locale"] = currentLocale
  if (typeof populate === "object" || typeof populate === "string") query["populate"] = populate

  const config = useRuntimeConfig()
  const strapiUrl = config.public.strapiUrl
  const token = import.meta.server ? config.strapiToken : config.public.strapiTokenPublic

  let data: any
  try {
    data = await $fetch(`${strapiUrl}/api/${endpoint}?${qs.stringify(query)}`, {
      headers: {
        ...(token ? { Authorization: `Bearer ${token}` } : {})
      }
    })
  } catch (error) {
    console.error(error)
    throw new Error("Failed to fetch data")
  }

  if (wrappedByKey) {
    data = data[wrappedByKey]
  }

  if (wrappedByList) {
    data = data[0]

    if (data === undefined) {
      throw new Error("Data is undefined")
    }
  }

  return data as T
}
